<template>
  <label
    class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    :for="htmlId"
  >CHART SIZE</label>
  <br />
  <select
    :id="htmlId"
    class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-compact sc3-select-menu-white-and-grey"
    v-model="chartSize"
    @change="handleChartSizeMenuChanged($event)"
  >
    <option
      v-for="chartSizeMenuOption in CHART_SIZE_MENU_OPTIONS_ARRAY"
      :key="chartSizeMenuOption.title"
      :value="chartSizeMenuOption.title"
    >{{ chartSizeMenuOption.title }}</option>
  </select>
</template>

<script lang="ts" setup>
  import { ref, toRefs, watch } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useChartStore } from '@/stores/chartStore';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { useModals } from '@/composables/useModals';
  import { CHART_SIZE_MENU_OPTIONS_ARRAY, getChartSizeObjFromChartSizeTitle } from '@/enums/chart-size-menu-options';

  const chartStore = useChartStore();
  const { isLoggedIn, isPro } = useAuthentication();
  const { launchCreateAccountModal, launchUpgradeToProModal } = useModals();
  const { chartSize: chartStoreChartSize } = storeToRefs(chartStore);
  const props = defineProps<{
    htmlId: string;
  }>();
  const { htmlId } = toRefs(props);
  const chartSize = ref(chartStoreChartSize.value);

  function handleChartSizeMenuChanged(e: Event) {
    if (!(e.target instanceof HTMLSelectElement)) {
      return;
    }

    const chartSizeTitle = e.target.value;
    const chartSizeOption = getChartSizeObjFromChartSizeTitle(chartSizeTitle);

    if (!isLoggedIn.value && chartSizeOption.isPayingMemberOnly) {
      syncChartSize();
      launchCreateAccountModal();
      return;
    }

    if (chartSizeOption.isProOnly && !isPro.value) {
      syncChartSize();
      launchUpgradeToProModal();
      return;
    }

    chartStoreChartSize.value = chartSizeTitle;
  }

  function syncChartSize() {
    chartSize.value = chartStoreChartSize.value;
  }

  watch(chartStoreChartSize, syncChartSize);
</script>
